import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';

const isDev = process.env.NODE_ENV === 'development';

const RootWrapper = isDev ? (
  <AuthProvider>
    <App />
  </AuthProvider>
) : (
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(RootWrapper);

reportWebVitals();